import mitt from "mitt";

const emitter = mitt();

export default {
  recenterMapLocation() {
    emitter.emit("recenterMapLocation");
  },
  scrollToTop() {
    emitter.emit("scrollToTop");
  },
  mapBound() {
    emitter.emit("mapBound");
  },
  clearSearch() {
    emitter.emit("clearSearch");
  },
  expandMap(val) {
    emitter.emit("expandMap", val);
  },
  scrollToTopMobile(val) {
    emitter.emit("scrollToTopMobile", val);
  },
  on: emitter.on,
  off: emitter.off
};
